<template>
    <c-modal class='text-center' :size="'tiny'" @close="close" :title="'Weet je het zeker?'">
        <p class="fs-small margin-b-24">{{confirm.text}}</p>
        <div class="c-modal__footer-buttons">
            <button class="c-btn c-btn--expanded" :class="buttonclass(index)" v-for="(button, index) in confirm.buttons" :key="'confirm-button-' + index" @click="button.action">{{button.text}}</button>
        </div>
    </c-modal>
</template>

<script>
import CModal from '@components/Modal';
import { mapState } from 'vuex';

export default {
    components: { CModal },
    computed: {
        ...mapState ({
            confirm: state => state.confirm
        })
    },
    methods: {
        close() {
            this.$store.dispatch('confirm/close');
        },
        buttonclass(index) {

            switch (index) {
                case 0:
                        return 'c-btn c-btn--hollow c-btn--secondary';
                    break;
                case 1:
                        return 'c-btn c-btn--secondary';
                    break;
                default:
                    return 'c-btn c-btn--primary';
            }
        }
    }
}
</script>
